import { m } from 'framer-motion'
// @mui
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Avatar from '@mui/material/Avatar'
import Divider from '@mui/material/Divider'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
// routes
import { paths } from 'src/routes/paths'
import { useRouter } from 'src/routes/hooks'
// auth
import { useAuthContext } from 'src/auth/hooks'
// components
import { varHover } from 'src/components/animate'
import { useSnackbar } from 'src/components/snackbar'
import CustomPopover, { usePopover } from 'src/components/custom-popover'

export default function AccountPopover() {
  const router = useRouter()

  const { logout, data } = useAuthContext()

  const { user } = data || {}

  const { enqueueSnackbar } = useSnackbar()

  const popover = usePopover()

  const OPTIONS = [
    {
      label: 'Profilo',
      linkTo: `${paths.app.profile}/${user?.id}`,
    },
  ]

  const handleLogout = async () => {
    try {
      await logout()
      popover.onClose()
    } catch (error) {
      console.error(error)
      enqueueSnackbar('Unable to logout!', { variant: 'error' })
    }
  }

  const handleClickItem = (path) => {
    popover.onClose()
    router.push(path)
  }

  if (!user) {
    return ''
  }

  return (
    <>
      <Button
        component={m.button}
        whileTap='tap'
        whileHover='hover'
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          height: 40,
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={user?.photoURL}
          alt={user?.name}
          sx={{
            width: 36,
            height: 36,
            mr: 2,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {user?.name.charAt(0).toUpperCase()}
        </Avatar>
        <Typography variant='overline' noWrap>
          {user?.name}
        </Typography>
      </Button>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
        <Box sx={{ p: 2, pb: 1.5 }}>
          <Typography variant='subtitle2' noWrap>
            {user?.name}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={handleLogout}
          sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
        >
          Logout
        </MenuItem>
      </CustomPopover>
    </>
  )
}
